import "./FeedPage.css";

import React from "react";

const FeedPage = () => {
  return (
    <>
    	
    </>
  );
};

export default FeedPage;